var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chartmdl"},[_c('div',{staticClass:"chartctn"},[_c('span',{staticClass:"title",staticStyle:{"color":"#505359"}},[_vm._v("6,54,800")]),_c('p',{staticClass:"body-2",staticStyle:{"color":"#FF8D24","letter-spacing":"0.16em","text-transform":"uppercase"}},[_vm._v(" Net Wealth ")])]),_c('canvas',{attrs:{"id":"myChart","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }